import React, { useEffect, useState } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from '../authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const Login = ({ onLoginSuccess }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize MSAL and handle redirect
  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();

        const authResult = await msalInstance.handleRedirectPromise();

        if (authResult) {
          console.log('Login successful via redirect:', authResult);

          // Store the access token (this is what we send to backend)
          if (authResult.accessToken) {
            localStorage.setItem('token', authResult.accessToken);
            console.log('Stored access token in localStorage');
          }
          onLoginSuccess();
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            console.log('User already authenticated:', accounts[0]);

            try {
              const silentRequest = {
                ...loginRequest,
                account: accounts[0]
              };
              const silentResult = await msalInstance.acquireTokenSilent(silentRequest);
              console.log('Silent token acquisition successful:', silentResult);
              localStorage.setItem('token', silentResult.accessToken);
              onLoginSuccess();
            } catch (silentError) {
              console.log('Silent token acquisition failed:', silentError);
            }
          }
        }
      } catch (error) {
        console.error('Error during MSAL initialization:', error);
        setError(getErrorMessage(error));
      } finally {
        setIsLoading(false);
      }
    };

    initializeMsal();
  }, [onLoginSuccess]);

  const getErrorMessage = (error) => {
    if (error.errorCode === 'AADSTS50105') {
      return 'Access Denied: You need to be granted access to this application. Please contact your administrator to assign you access to the VEG_TOMATO_BASERATE_MODEL application.';
    } else if (error.errorCode === 'user_cancelled') {
      return 'Login was cancelled. Please try again.';
    } else if (error.message) {
      return error.message;
    }
    return 'An unexpected error occurred during login.';
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      console.log('Login successful:', loginResponse);
      console.log('Access token:', loginResponse.accessToken);
      console.log('ID token:', loginResponse.idToken);

      if (loginResponse.accessToken) {
        localStorage.setItem('token', loginResponse.accessToken);
        console.log('Stored access token in localStorage');
      }

      onLoginSuccess();
    } catch (error) {
      console.error('Login failed:', error);
      setError(getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div>Loading authentication...</div>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>Authentication Required</h2>
      <p>Please sign in with your Azure account to access the Tomato Yield Predictor.</p>

      {error && (
        <div style={{
          color: 'red',
          backgroundColor: '#ffe6e6',
          padding: '10px',
          margin: '10px 0',
          borderRadius: '5px',
          border: '1px solid #ff9999'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      <button
        onClick={handleLogin}
        disabled={isLoading}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#0078d4',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: isLoading ? 'not-allowed' : 'pointer'
        }}
      >
        {isLoading ? 'Signing in...' : 'Login with Azure SSO'}
      </button>
    </div>
  );
};

export default Login;